export default __webpack_public_path__ + "assets/images/a375f37614c713f98eb85e8c1967b8c6.png";